import { useState, useCallback, useRef } from 'react'

// The zoom level of the OT board and list: 50-150 %, kept per view in the browser.
export const NIVELES = [50, 60, 70, 80, 90, 100, 110, 125, 150]

function leer(clave) {
  try {
    const n = Number(localStorage.getItem(clave))
    return NIVELES.includes(n) ? n : 100
  } catch { return 100 }
}

// Does the box (or a table scroller inside it that keeps its own scroll) have to be scrolled sideways?
function desborda(el) {
  return [el, ...el.querySelectorAll('[data-anchos-propios], .overflow-x-auto, .overflow-auto')].some(x => x.scrollWidth > x.clientWidth + 1)
}

export function useZoom(clave) {
  const [zoom, setZoomEstado] = useState(() => leer(clave))
  const zonaRef = useRef(null)              // the box ZonaZoom zooms: "Ajustar" measures it
  const ajusteId = useRef(0)
  const setZoom = useCallback((n) => {
    setZoomEstado(n)
    try { localStorage.setItem(clave, String(n)) } catch { /* private mode: it just is not kept */ }
  }, [clave])
  const paso = useCallback((dir) => {
    ajusteId.current += 1                   // a click while fitting stops the fitting
    setZoomEstado(actual => {
      const i = NIVELES.indexOf(actual)
      const n = NIVELES[Math.min(NIVELES.length - 1, Math.max(0, i + dir))]
      try { localStorage.setItem(clave, String(n)) } catch { /* private mode */ }
      return n
    })
  }, [clave])
  const acercar = useCallback(() => paso(1), [paso])
  const alejar = useCallback(() => paso(-1), [paso])
  const restablecer = useCallback(() => { ajusteId.current += 1; setZoom(100) }, [setZoom])

  // The biggest level at which everything fits the width, with no sideways scroll: try from the biggest down.
  const ajustar = useCallback(() => {
    const el = zonaRef.current
    if (!el) return
    const id = ++ajusteId.current
    let i = NIVELES.length - 1
    setZoom(NIVELES[i])
    const probar = () => {
      if (id !== ajusteId.current || !desborda(el) || i === 0) return
      i -= 1
      setZoom(NIVELES[i])
      requestAnimationFrame(probar)
    }
    requestAnimationFrame(() => requestAnimationFrame(probar))
  }, [setZoom])

  return { zoom, setZoom, acercar, alejar, restablecer, ajustar, zonaRef }
}
